import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import './AssistantPanel.css';

export default function AssistantPanel() {
  const { user } = useContext(AuthContext);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const sendMessage = async () => {
    const userMsg = { from: 'user', text: input };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    const res = await fetch('/api/chat', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ uid: user.uid, message: userMsg.text })
    });
    const { reply } = await res.json();
    setMessages(prev => [...prev, { from: 'bot', text: reply }]);
  };

  return (
    <div className="assistant-panel">
      <h2>AI Assistant</h2>
      <div className="chat-window">
        {messages.map((m,i) => (
          <div key={i} className={m.from}>{m.text}</div>
        ))}
      </div>
      <div className="chat-input">
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key==='Enter' && sendMessage()}
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}
